import React, { useEffect } from 'react';
import { Badge, Typography, Tag } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon, { User } from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './style';
import { Popover } from '../../ui/popup/popup';
import { logOut } from '../../../redux/authentication/actionCreator';
import { mockStore } from '../../../utility/mockStore';

const { Text } = Typography;

function AuthInfo() {
    const dispatch = useDispatch();
    const history = useNavigate();

    const SignOut = e => {
        e.preventDefault();
        dispatch(logOut());
        setTimeout(() => {
            history('/login', { replace: true });
        }, 100);
    };

    const userDetails = useSelector((state) => state.auth.loginData);
    useEffect(() => {
        if (!userDetails.name) {
            dispatch(logOut());
        }
        // eslint-disable-next-line
    }, [userDetails]);

    const applications = mockStore.getApplications();
    const rejectedApps = applications.filter(app => app.status === 'Rejected');
    const rejectedCount = rejectedApps.length;

    const notificationContent = (
        <div style={{ width: '280px', padding: '4px' }}>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '12px', 
                paddingBottom: '8px', 
                borderBottom: '1px solid #f0f0f0' ,
                
            }}>
                <Text strong style={{ fontSize: '14px' }}>Notifications</Text>
                {rejectedCount > 0 && <Tag color="error" style={{ margin: 0 }}>{rejectedCount} New</Tag>}
            </div>
            {rejectedCount > 0 ? (
                <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                    {rejectedApps.map(app => (
                        <div 
                            key={app.id} 
                            style={{ 
                                padding: '10px 12px', 
                                borderRadius: '8px', 
                                background: '#fff1f0', 
                                border: '1px solid #ffa39e',
                                marginBottom: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                hover: { background: '#ffe8e6' }
                            }}
                            onClick={() => history(`/History/${app.id}`)}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text strong style={{ fontSize: '12px', color: '#cf1322' }}>Quote Rejected</Text>
                                <Text type="secondary" style={{ fontSize: '10px' }}>{app.date}</Text>
                            </div>
                            <div style={{ marginTop: '4px', fontSize: '11px', color: '#434343', lineHeight: '1.4' }}>
                                Quote for <strong>{app.deviceModel}</strong> ({app.id}) was rejected by the store.
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div style={{ padding: '24px 0', textAlign: 'center', color: '#bfbfbf' }}>
                    <FeatherIcon icon="bell-off" size={24} style={{ marginBottom: '8px', opacity: 0.6 }} />
                    <div>No new notifications</div>
                </div>
            )}
        </div>
    );

    const userContent = (
        <UserDropDwon>
            <div className="user-dropdwon">
                <ul className="user-dropdwon__links">
                    <li>
                        <Link to="/profile">
                            <User icon="lock" /> Profile
                        </Link>
                    </li>
                    <li>
                        <Link to="/profile/change-password">
                            <FeatherIcon icon="lock" /> Change Password
                        </Link>
                    </li>
                </ul>
                <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
                    <FeatherIcon icon="log-out" /> Sign Out
                </Link>
            </div>
        </UserDropDwon>
    );

    return (
        <InfoWraper>
            <div className="nav-author" style={{ display: 'flex', alignItems: 'center', gap: '16px',marginRight: 12 }}>
                <Popover placement="bottomRight" content={notificationContent} action="click">
                    {/* <Link
                        to="#"
                        className={rejectedCount > 0 ? 'notification-bell notification-bell--active' : 'notification-bell'}
                        style={{ display: 'flex', alignItems: 'center', position: 'relative', padding: '4px' }}
                    >
                        <Badge count={rejectedCount} size="small" style={{ boxShadow: 'none' }}>
                            <FeatherIcon icon="bell" size={20} style={{ color: '#fff' }} />
                        </Badge>
                    </Link> */}
                </Popover>

                <Popover placement="bottomRight" content={userContent} action="click">
                    <Link to="#" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px' }}>
                        <span className='user-first__name' style={{ color: '#fff', fontWeight: 700 }}>
                            {userDetails?.name ? userDetails.name.toUpperCase().split(" ")[0] : ''}
                        </span>
                        <div style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            background: 'rgba(255, 255, 255, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'background 0.3s ease'
                        }}>
                            <FeatherIcon icon="user" size={16} style={{ color: '#fff' }} />
                        </div>
                    </Link>
                </Popover>
            </div>
        </InfoWraper>
    );
}

export default AuthInfo;
